import React from "react";
import { DISCOUNT_TYPES } from "../../Helper/Cotizacion/quoteCalculations";
import { formatCLP } from "../../Helper/Cotizacion/currencyUtils";

const QuoteDiscountSection = ({ globalDiscount, onChange }) => {
	const handleField = (event) => {
		const { name, value } = event.target;
		onChange({
			...globalDiscount,
			[name]: name === "value" ? (value === "" ? "" : Math.max(0, Number(value))) : value,
		});
	};

	return (
		<section style={{ marginBottom: "24px" }}>
			<h5 style={{ marginBottom: "8px" }}>4. Descuento general</h5>
			<div className="grid-x grid-margin-x">
				<div className="cell small-12 medium-4">
					<label>
						Tipo de descuento general
						<select
							name="type"
							value={globalDiscount.type || DISCOUNT_TYPES.NONE}
							onChange={handleField}
						>
							<option value={DISCOUNT_TYPES.NONE}>Sin descuento</option>
							<option value={DISCOUNT_TYPES.PERCENT}>Porcentaje</option>
							<option value={DISCOUNT_TYPES.FIXED}>Monto fijo</option>
						</select>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>
						Valor
						<input
							type="number"
							name="value"
							min="0"
							value={globalDiscount.value}
							onChange={handleField}
							disabled={globalDiscount.type === DISCOUNT_TYPES.NONE}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>Monto aplicado</label>
					<div style={{ paddingTop: "8px", fontWeight: 600 }}>
						{formatCLP(globalDiscount.amount || 0)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default QuoteDiscountSection;
